module.exports = __webpack_public_path__ + "static/img/seven_bg1.781c0a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/seven_bg1.png
// module id = LblY
// module chunks = 13